import React from "react"
import SvgIcon from "@mui/material/SvgIcon"
import styles from "./borderedSection.module.scss"

export default function BorderedSection({ icon, title, children, ...otherProps }) {
    return (
        <div className={styles.mainContainer} {...otherProps}>
            <div className={styles.header}>
                <div className={styles.headerBorderBefore}></div>
                {(icon || title) && (
                    <div className={styles.headerTitle}>
                        {icon && <SvgIcon component={icon} />}
                        {title && <span className={styles.title}>{title}</span>}
                    </div>
                )}
                <div className={styles.headerBorderAfter}></div>
            </div>
            <div className={styles.childrenContainer}>{children}</div>
        </div>
    );
}
